import React from 'react';

//Icon
import CloseIcon from '@material-ui/icons/Close';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

//Img
import imgOk from '../img/help/help_main-photo_ok.jpg';
import imgNg1 from '../img/help/help_main-photo_ng1.jpg';
import imgNg2 from '../img/help/help_main-photo_ng2.jpg';
import imgNg3 from '../img/help/help_main-photo_ng3.jpg';

class Comp extends React.Component {
  render() {
  	return (
    <div>
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          justifyContent:'center',
          userSelect:'none',
        }}
      >
        <div style={{position:'relative'}}>
          <img
            src={imgOk}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <RadioButtonUncheckedIcon
            style={{position :'absolute', top:'5px', left:'5px', color:'#CD4695', background:'rgba(255, 255, 255, 0.5)'}}
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            OK
          </div>
        </div>
        <div style={{position:'relative'}}>
          <img
            src={imgNg1}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <CloseIcon
            style={{position :'absolute', top:'5px', left:'5px', color:'#4376AB', background:'rgba(255, 255, 255, 0.5)'}}
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            サングラス
          </div>
        </div>
        <div style={{position:'relative'}}>
          <img
            src={imgNg2}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <CloseIcon
            style={{position :'absolute', top:'5px', left:'5px', color:'#4376AB', background:'rgba(255, 255, 255, 0.5)'}}
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            複数
          </div>
        </div>
        <div style={{position:'relative'}}>
          <img
            src={imgNg3}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <CloseIcon
            style={{position :'absolute', top:'5px', left:'5px', color:'#4376AB', background:'rgba(255, 255, 255, 0.5)'}}
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            70%以下
          </div>
        </div>
      </div>
      <div style={{padding:5,fontSize:'0.9em',color:'#666'}}>
        「顔が70%以上確認できない」「サングラス」「過去に撮影された」「加工が多い」画像は掲載できません。
      </div>
    </div>
  	)
  }
}

export default Comp;
